import React, { useEffect } from "react";
import { render } from 'react-dom';
import { SoftwareUpdateRibbon } from "./components/SoftwareUpdateRibbon";
import { QueryClient, QueryClientProvider } from "react-query";

const queryClient = new QueryClient();

let MAX_INTERVAL = 5000

let count = 0

const interval = setInterval(() => {
  const rootNode = document.getElementById("software-update-ribbon");

  if (count === MAX_INTERVAL && !rootNode) {
    clearInterval(interval)
  }

  if (rootNode) {
    render(
      <QueryClientProvider client={queryClient}>
      <SoftwareUpdateRibbon />
    </QueryClientProvider>
     ,
      rootNode
    )
    clearInterval(interval)
  }

  count += 10
}, 10)

